// Material UI
import { makeStyles } from '@material-ui/core'
// Consts
import Colors from './../../../constants/Colors'

export default makeStyles(theme => ({
  label: {
    color: Colors.PRIMARY_FONT_COLOR,
    fontFamily: 'Poppins',
    fontSize: '15px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    marginLeft: '7px',
  },
  root: {},
}))
